import {Component, OnInit, ViewChild} from '@angular/core';
import {language} from '../../../language/vn';
import {SoVanThuService} from '../../../service/info/service-sovanthu';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { Subject} from 'rxjs';
import {UsersService} from '../../../service/staff/service-users';
import {GroupSelectComponent} from '../group/groupselect.component';
import {GroupUserDefine} from '../../../models/staff/groupuserdefine';
import {GroupUserDefineService} from '../../../service/staff/service-groupuserdefine';
import {GroupStaffsService} from '../../../service/staff/service-groupstaffs';
import {GroupStaffs} from '../../../models/staff/groupstaffs';
import {Users} from '../../../models/staff/users';
@Component({
  templateUrl: './password.component.html'

})export class ChangePasswordComponent implements OnInit {
  public language = language;
  public frmGroup: FormGroup;
  public id: number = 0;
  public isEdit: boolean = false;
  public submitValidate = false;
  public onClose: Subject<boolean>;
  public userItem: Users = new Users();
  constructor( public usersService: UsersService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public _bsModalRef: BsModalRef

  ) {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      userName: new FormControl(),
      matKhauNew: new FormControl(),
      matKhau1: new FormControl(),
      staffID: new FormControl('0')


    });
    this.frmGroup = this.formBuilder.group({
      userName: ['' , Validators.compose([validateEmpty]) ],
      matKhauNew: ['' , Validators.compose([validateEmpty]) ],
      matKhau1: ['' , Validators.compose([validateEmpty]) ],
      staffID: ['', Validators.nullValidator],
      id: ['', Validators.nullValidator]
    });

  }



  get f() { return this.frmGroup.controls; }
  edit(id: number) {
    this.id = id;
    this.isEdit = id != 0 ? true: false;
    this.usersService.getById(id).pipe(first())
      .subscribe(x => {
        this.frmGroup.patchValue(x);
        this.userItem = x;

      });
  }
  updateItem()
  {
    this.userItem.staffID= this.frmGroup.value.staffID;
    this.userItem.id = this.id;
    this.userItem.userName = this.frmGroup.value.userName;
    this.userItem.password = this.frmGroup.value.matKhauNew;
    this.usersService.update(this.userItem).subscribe({
      next: (data) => {
        if(data.staffID !==0) {
          this.toastr.success(language.changepassword_success, language.message);
          this.onConfirm();

        }else
          this.toastr.error(language.error, language.message);
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
    if(this.frmGroup.value.matKhauNew!= this.frmGroup.value.matKhau1)
    {
      this.toastr.error(language.nhaplaimatkhau_error, language.message);
      return;
    }
      this.updateItem();

  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}
